var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0944 27.7288C22.0322 27.3282 22 26.9179 22 26.5C22 22.0817 25.6052 18.5 30.0526 18.5C34.4999 18.5 38.1052 22.0817 38.1052 26.5C38.1052 27.4981 37.9213 28.4535 37.5852 29.3345C37.5154 29.5175 37.4804 29.609 37.4646 29.6804C37.4489 29.7512 37.4428 29.801 37.4411 29.8735C37.4394 29.9466 37.4493 30.0272 37.4692 30.1883L37.8717 33.4585C37.9153 33.8125 37.9371 33.9895 37.8782 34.1182C37.8266 34.231 37.735 34.3205 37.6211 34.3695C37.4911 34.4254 37.3146 34.3995 36.9617 34.3478L33.7765 33.8809C33.6101 33.8565 33.527 33.8443 33.4512 33.8448C33.3763 33.8452 33.3245 33.8507 33.2511 33.8661C33.177 33.8817 33.0823 33.9172 32.893 33.9881C32.0097 34.319 31.0524 34.5 30.0526 34.5C29.6344 34.5 29.2237 34.4683 28.8227 34.4073M23.6316 38.5C26.5965 38.5 29 36.0376 29 33C29 29.9624 26.5965 27.5 23.6316 27.5C20.6667 27.5 18.2632 29.9624 18.2632 33C18.2632 33.6106 18.3603 34.1979 18.5395 34.7467C18.6153 34.9787 18.6532 35.0947 18.6657 35.1739C18.6786 35.2567 18.6809 35.3031 18.6761 35.3867C18.6714 35.4668 18.6514 35.5573 18.6113 35.7383L18 38.5L20.9948 38.091C21.1583 38.0687 21.24 38.0575 21.3114 38.058C21.3865 38.0585 21.4264 38.0626 21.5001 38.0773C21.5701 38.0912 21.6742 38.1279 21.8823 38.2014C22.4306 38.3949 23.0191 38.5 23.6316 38.5Z",
    stroke: "#0F47C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F7F9FF",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedicon);
export default __webpack_public_path__ + "static/media/Featured icon.784f256f.svg";
export { ForwardRef as ReactComponent };